const homePage: Record<string, Record<string, string> | string> = {
    headerLinks: {
        commissions: 'Экспертные группы',
        subjects: 'Инициативы',
    },
};

export default homePage;
